import { FC, HTMLAttributes } from "react";
import clsx from "classnames";
import { Image, ProgressIndicator } from "@onmo/ui";
import { DefaultTheme } from "../../../constants/theme";
import { useStyles } from "./GameLoading.style";

interface IGameLoadingProps {
  gameImageUrl: string;
}

export const GameLoading: FC<
  IGameLoadingProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const classes = useStyles();
  const { gameImageUrl, className, ...otherProps } = props;

  return (
    <div {...otherProps} className={clsx(classes.root, className)}>
      <Image src={gameImageUrl} className={classes.bgImg} />
      <div className={classes.main}>
        <Image src={gameImageUrl} className={classes.gameImg} />
        <ProgressIndicator
          value={{
            initial: 0,
            target: 100,
            total: 100,
          }}
          timing={2000}
          color={DefaultTheme.colors.primary}
          className={classes.progress}
          size="small"
          underBackground="primary"
        />
      </div>
    </div>
  );
};
